import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { PurchaseOrderOutline } from '@/hooks/api/models';
import { useMemo } from 'react';
import { PurchaseOrderOutlineLogic } from '@/hooks/api/models/logics';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { useNextPurchaseOrders } from '@/hooks/api/0572_next_purchase_orders';

export const NextPurchaseOrdersElement = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _po_ } = useCurrentPurchaseOrder();
  const orderParams = { identifier: _w_!.identifier, team_id: _t_!.id, id: _po_!.id };
  const { data: nextOrders } = useNextPurchaseOrders(orderParams);

  if (nextOrders == null || nextOrders.length === 0) return null;

  return (
    <>
      <hr className="horizontal dark my-3" />

      <div className="table-responsive">
        <table className="table align-items-center">
          <thead>
            <tr>
              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2">以降のプロジェクト</th>
            </tr>
          </thead>
          <tbody>{nextOrders?.map((d) => <NextPurchaseOrderRow key={`next-order-${d.id}`} d={d} />)}</tbody>
        </table>
      </div>
    </>
  );
};

type Props = {
  d: PurchaseOrderOutline;
};
const NextPurchaseOrderRow = ({ d }: Props) => {
  const orderLabel = useMemo(() => {
    return PurchaseOrderOutlineLogic.toLabel(d);
  }, [d]);

  return (
    <tr>
      <td className="font-weight-bold text-sm text-dark mb-1">{orderLabel}</td>
    </tr>
  );
};
